module.exports = __webpack_public_path__ + "static/media/broker-aim.18defecd.svg";